const merge = require('lodash.merge');
const config = require('./default').default;

/* eslint-disable */
if (['development', 'test', 'production'].includes(process.env.NODE_ENV)) {
  const override = require(`./${process.env.NODE_ENV}`).default;
  merge(config, override);
}

export default config;
